/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormDateTimeField, {
  FormDateTimeFieldProps
} from '../../../../client/js/components/form/fields/FormDatetimeField'

function StartDateField (props: FormDateTimeFieldProps) {
  const { name = 'startDate', ...others } = props
  const intl = useIntl()
  return (
    <FormDateTimeField
      label={intl.formatMessage({
        id: 'start_date',
        defaultMessage: 'Date de début'
      })}
      name={name}
      {...others}
    />
  )
}

export default StartDateField
